import React, { Component } from 'react';
import { ExportExcelFile } from "../../../General/Excel/ExcelFileTemplate.js";
import { fetchExportarLiquidacionesApi } from '../../../../api/axios.js';
import { formatoFechaSinHora } from "../../../../utilities/formatoFecha.js";
import { formatoDecimal } from "../../../../utilities/formatoNumeros.js";
import { toast } from 'react-toastify';
import MiniSpinner from '../../../General/MiniSpinner.js';

class LiquidacionToExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      excelDataSet: []
    };
  }

  exportExcel = async () => {
    this.setState({ isLoading: true });
    if (this.state.excelDataSet.length < 1) {
      this.fetchDataExcel({ idLiquidacion: this.props.id });
    } else {
      this.setState({ isLoading: false });
    }
  }

  fetchDataExcel = async (request) => {
    let response;
    try {
      response = await fetchExportarLiquidacionesApi(request);
    } catch (e) {
      toast.error('No se pudo descargar el excel');
      this.setState({ isLoading: false });
      return;
    }
    this.setDataExcel(response);
  }

  setDataExcel = (liquidacionesResponse) => {
    let ordenes = liquidacionesResponse?.ordenes ?? [];
    let novedades = liquidacionesResponse?.novedades ?? [];
    const { rebateConIva, totalOrdenes } = liquidacionesResponse;
    let excelLiquidaciones = [];
    const DEFAULT_EXCEL = {
      "Razon Social": "",
      "Tipo Movimiento": "",
      "Id Orden": "",
      "Id Anulación": "",
      "SKU Seller": "",
      "SKU Market": "",
      "Fecha": "",
      "Descripción": "",
      "Monto Operación": "",
      "Comisión Con Iva": "",
      "Comisión Sin Iva": "",
      "Peso Hasta": "",
      "Peso Aforado": "",
      "Envío Gratis": "",
      "Código Postal": "",
      "Fee Logístico": "",
      "Fee Logístico Sin Iva": "",
      "Novedades Con Iva": "",
      "Novedades Sin Iva": "",
      "Rebate Con Iva": "",
      "Rebate Sin Iva": "",
      "Rebate Unitario Con Iva": "",
      "Neto A Pagar": "",
      "Total Ordenes": "",
      "Total Rebate Con Iva": ""
    };

    for (let index = 0; index < ordenes.length; index++) {
      var orden = ordenes[index];

      let row = {
        ...DEFAULT_EXCEL,
        "Razon Social": this.props.razonSocial,
        "Tipo Movimiento": orden?.idAnulacion ? "Anulación" : "Orden",
        "Id Orden": orden.idVenta,
        "Id Anulación": orden?.idAnulacion,
        "SKU Seller": orden?.skuSeller,
        "SKU Market": orden?.skuMarket,
        "Fecha": formatoFechaSinHora(orden?.fecha),
        "Descripción": orden.tipoPublicacion,
        "Monto Operación": formatoDecimal(orden.importe),
        "Comisión Con Iva": formatoDecimal(orden.comisionTotal),
        "Comisión Sin Iva": formatoDecimal(orden.comisionNeto),
        "Peso Hasta": orden.pesoHasta,
        "Peso Aforado": orden.pesoAforado,
        "Envío Gratis": orden.envioGratis ? "Con Envío Gratis" : "Sin Envío Gratis",
        "Código Postal": orden?.codigoPostal,
        "Fee Logístico": formatoDecimal(orden.importeFee),
        "Fee Logístico Sin Iva": formatoDecimal(orden.importeFeeSinIva),
        "Rebate Con Iva": formatoDecimal(orden.rebateConIva),
        "Rebate Sin Iva": formatoDecimal(orden.rebateSinIva),
        "Rebate Unitario Con Iva": formatoDecimal(orden.rebateUnitario),
        "Neto A Pagar": formatoDecimal(orden.netoAPagar),
      };

      excelLiquidaciones.push(row);
    }

    for (let index = 0; index < novedades.length; index++) {
      var novedad = novedades[index];

      let row = {
        ...DEFAULT_EXCEL,
        "Razon Social": this.props.razonSocial,
        "Tipo Movimiento": "Novedad",
        "Id Orden": novedad.idOrden,
        "Fecha": formatoFechaSinHora(novedad?.fechaNovedad),
        "Descripción": novedad.descripcion,
        "Novedades Con Iva": formatoDecimal(novedad.novedadesConIva),
        "Novedades Sin Iva": formatoDecimal(novedad.novedadesSinIva),
        "Neto A Pagar": formatoDecimal(novedad?.importeNovedad),
      };

      excelLiquidaciones.push(row);
    }

    let row = {
      ...DEFAULT_EXCEL,
      "Total Ordenes": totalOrdenes,
      "Total Rebate Con Iva": formatoDecimal(rebateConIva),
    }

    excelLiquidaciones.push(row);

    if (excelLiquidaciones.length === 0) {
      toast.warn("No se encontraron datos");
      this.setState({ isLoading: false });
      return;
    }

    const dataSet = {
      fileResultName: `${this.props.razonSocial} Liquidación N° ${this.props.id}`,
      sheetName: "Liquidaciones",
      columns: excelLiquidaciones
    };

    this.setState({ isLoading: false, excelDataSet: dataSet });
  }

  render() {


    return (
      <div className="d-flex">
        {this.state.isLoading && <MiniSpinner />}
        <ExportExcelFile dataSet={this.state.excelDataSet} fetchDataExcel={this.exportExcel}>
          <button
            className="btn btn-sm background-rojo-megatone ms-3"
            disabled={this.state.isLoading}
          >
            Exportar a Excel
          </button>
        </ExportExcelFile>
      </div>
    );
  }
}

export default LiquidacionToExcel;
